import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./styles.css";
;
const Gallery = ({ mediaList, countPerPage, ctaRef }) => {
    const formatProductUrl = (productUrl, index) => {
        if (!productUrl)
            return null;
        const url = new URL(productUrl);
        const pageNumber = Math.floor(index / countPerPage) + 1;
        const tileNumber = index % countPerPage;
        const hasCta = ctaRef && ctaRef !== "ugc view gallery";
        const newCtaRef = `${hasCta ? `${ctaRef} ` : ''}ugc asom page_${pageNumber}_${tileNumber}`;
        url.searchParams.append("ctaref", newCtaRef);
        url.searchParams.append("featureref1", "ugc asom page");
        return url.toString();
    };
    return (_jsx("ul", { className: styles.content, children: mediaList.map((item, i) => {
            const { name, pdpUrl } = item.products[0];
            const normalImageUrl = item.assets.find(asset => asset.type === 'normal').url;
            const username = item.username;
            return (_jsx("li", { children: _jsxs("a", { href: formatProductUrl(pdpUrl, i), children: [_jsx("img", { alt: name, src: normalImageUrl }), _jsx("span", { className: "app_london3", children: username })] }) }, i));
        }) }));
};
export default Gallery;
